import { notification } from 'antd';
import { useState } from 'react';

import { downloadFilesApi } from '@/integrations/index.api';
import { handleError } from '@/services/handleError';
import { useAppDispatch, useAppSelector } from '@/store';
import { getAttachedFilesByReqId } from '@/store/financingStep.slice';

import useAutoCredRequestId from '../../hooks/useAutoCredRequestId';

const useLoadDocuments = () => {
  const dispatch = useAppDispatch();

  const { selectedBank } = useAppSelector((state) => state.financingStep);

  const { requestId } = useAutoCredRequestId();

  const [isFilesLoading, setIsFilesLoading] = useState(false);

  const handleLoadEuBankFiles = async () => {
    try {
      setIsFilesLoading(true);
      if (selectedBank?.bank.name !== 'eu_bank_v2')
        await downloadFilesApi.downloadEubankFilesManually(
          selectedBank?.id || ''
        );
      setTimeout(async () => {
        await dispatch(getAttachedFilesByReqId(requestId));
        setIsFilesLoading(false);
        notification.success({
          title: 'Файлы обновлены',
          description: 'Файлы были обновлены',
          duration: 5
        });
      }, 25000);
    } catch (error) {
      handleError(error, {
        customTitle: 'Ошибка обновления файлов',
        onError: () => {
          setIsFilesLoading(false);
        }
      });
    }
  };

  return { isFilesLoading, handleLoadEuBankFiles };
};

export default useLoadDocuments;
